import axios from "axios";
import {apiUrl} from "../../../App";

export async function updateCommunityUserRoleUseCase(channelId: string, userId: string, role: string) {
    return await axios.put(`${apiUrl}/admin/chat/channels/${channelId}/users/${userId}/role`, { role }, {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
    });
}